export default __webpack_public_path__ + "media/images/portfolio/gallery-08-370x220-f7922fb7b0fd7bd659755ef37ccb5f5a.jpg";